import type { SVGProps } from 'react';

import { strokeStyle } from '../Illustration.css';
import { useIllustrationShades } from '../Illustration.hooks';

type Props = SVGProps<SVGSVGElement> & {
  strokeWidth: number;
};

export const HandsShaking = ({ strokeWidth, ...delegated }: Props) => {
  const shades = useIllustrationShades();

  return (
    <svg fill="none" height="78" viewBox="0 0 112 78" width="112" xmlns="http://www.w3.org/2000/svg" {...delegated}>
      <path className={strokeStyle} d="M60.93 24.26h-.01" strokeWidth={strokeWidth} />
      <path
        className={strokeStyle}
        d="M65.31.61c-.21 1.33-1.02 3.24-3.55 4.79-2.55 1.56-5.03.82-6.63-.06 3.23-1.55 5.39-3.15 8.19-4.4q1.04-.23 1.99-.33Z"
        fill={shades.white}
        strokeWidth={strokeWidth}
      />
      <path
        className={strokeStyle}
        d="M83.18 41.79c-.76-3.59-5.9-5.2-8.61-3.33-1.78 1.21-2.59 3.79-2.96 5.68q1.89.06 3.64-.14c2.37-.26 4.46-.69 6.18-1.37.38 2.37-.78 5.85-4.79 8.97a12.5 12.5 0 0 1-5.73 2.19c-4.31 10.64-20.16 11.99-34.84 6.42-24.66-13.69-19.89-46 3.33-50.58 7.75-1.09 12.34-2.66 15.73-4.29 1.6.88 4.07 1.62 6.63.06C64.3 3.85 65.1 1.93 65.31.61h.01c15.65-1.78 12.78 19.04-4.4 23.65 2.34.93 4.56 1.66 6.45 2.06 9.14 1.88 18.04 1.81 18.97 8.63.45 3.23-.78 5.4-3.17 6.84z"
        fill={shades.secondary.medium}
        strokeWidth={strokeWidth}
      />
      <path className={strokeStyle} d="M71.61 44.14c-8.74-.25-18.9-4.05-18.9-4.05" strokeWidth={strokeWidth} />
      <path
        className={strokeStyle}
        d="M83.18 41.79q-.78.47-1.75.84A24 24 0 0 1 75.25 44q-1.75.2-3.64.14c.37-1.89 1.18-4.47 2.96-5.68 2.71-1.87 7.85-.26 8.61 3.33Z"
        fill={shades.white}
        strokeWidth={strokeWidth}
      />
      <path className={strokeStyle} d="M60.93 24.26h-.01c-8.9-3.53-19.39-9.81-19.39-9.81" strokeWidth={strokeWidth} />
      <path className={strokeStyle} d="M52.71 52.31c1.76.37 11.06 2.61 18.19 1.47" strokeWidth={strokeWidth} />
      <path
        className={strokeStyle}
        d="m77.31 61.11-.98.28c5.59-6.43 7.54-13.36 8.07-20.51 1.57-1.39 2.3-3.31 1.94-5.93-.76-5.54-6.75-6.53-13.86-7.72h-.01q-2.48-.4-5.07-.9a46 46 0 0 1-6.8 5.41h-.01l-.31.2c-5.5 3.38-16.88 2.82-19.49-4.25a6 6 0 0 1 1.09-6.25c1.21 1.7 3.41 3.85 6.46 3.1 2.48-.61 3.65-2.49 3.47-4.45a5.5 5.5 0 0 0-2.35-3.79 82 82 0 0 1 8.88-3.29 43 43 0 0 1 16.71-1.3c3.23.41 6.43 1.26 9.14 2.75 5.92 3.26 10.44 10.32 11.55 15.38 3.49 15.96-6.75 27.62-18.44 31.27z"
        fill={shades.white}
        strokeWidth={strokeWidth}
      />
      <path
        className={strokeStyle}
        d="M84.41 40.88c-.53 7.15-2.49 14.08-8.07 20.51a20.7 20.7 0 0 1-12.31-.36 14 14 0 0 0 6.89-7.25 12.6 12.6 0 0 0 5.73-2.19c4.01-3.12 5.18-6.6 4.79-8.97q.96-.38 1.75-.84.69-.4 1.23-.9z"
        fill={shades.black}
        strokeWidth={strokeWidth}
      />
      <path d="M67.41 26.33c1.97-1.87 3.22-3.31 3.22-3.31z" fill={shades.white} />
      <path className={strokeStyle} d="M67.41 26.33c1.97-1.87 3.22-3.31 3.22-3.31" strokeWidth={strokeWidth} />
      <path
        className={strokeStyle}
        d="M48.35 24.54c-3.06.76-5.25-1.4-6.46-3.1 1.15-1.44 2.91-2.72 5.08-3.9q1.17-.64 2.5-1.24a5.4 5.4 0 0 1 2.35 3.79c.19 1.96-.99 3.84-3.47 4.45Z"
        fill={shades.secondary.medium}
        strokeWidth={strokeWidth}
      />
      <path
        className={strokeStyle}
        d="M72.48 27.24a25.5 25.5 0 0 1-11.86 4.51 46 46 0 0 0 6.8-5.41q2.59.51 5.07.9z"
        fill={shades.black}
        strokeWidth={strokeWidth}
      />
      <path
        className={strokeStyle}
        d="M29.41 40.56q-1.4.78-2.75 1.82c-2.45 1.89-5.91 6.27-5.86 10.28-4.33.26-10.23-3.02-8.48-10.79a30 30 0 0 1 .54-2.04c.9 1.76 2.61 3.63 5.5 3.12 4.67-.84 5.8-7.51.52-11.31a8.3 8.3 0 0 1 4.88-.97c3.91.45 5.6 5.8 5.65 9.88z"
        fill={shades.white}
        strokeWidth={strokeWidth}
      />
      <path
        className={strokeStyle}
        d="M38.71 40.76c-2.69-2.4-6.02-1.99-9.3-.2q-1.4.78-2.75 1.82c-2.45 1.89-5.91 6.27-5.86 10.28a6 6 0 0 0 1.08 3.38c1.5 2.13 4.53 2.61 7.67 2.02 3.65-.67 7.47-2.77 9.16-5.38l.17-.3c2.95-4.74 2.08-9.6-.17-11.63zm-1.29 8.9a5.16 5.16 0 0 1-8.01-.2c-1.99-2.46-.25-6.32 2.27-6.32s7.73 4.33 5.75 6.51z"
        fill={shades.white}
        strokeWidth={strokeWidth}
      />
      <path
        className={strokeStyle}
        d="m38.88 52.39-.17.3c-1.7 2.6-5.51 4.71-9.16 5.38-.88 2.19-.93 5.04 1.91 6.79 4.43 2.72 14.08-.43 15.28-5.47 1.08-4.58-1.14-7.6-7.85-6.99zm4.69 7.92c-.61 1.54-3.16.59-3.5-.77-.35-1.36 1.03-3.24 2.06-2.3 0 0 2.04 1.54 1.45 3.07z"
        fill={shades.white}
        strokeWidth={strokeWidth}
      />
      <path
        className={strokeStyle}
        d="M43.57 60.31c-.61 1.54-3.16.59-3.5-.77-.35-1.36 1.03-3.24 2.06-2.3 0 0 2.04 1.54 1.45 3.07z"
        fill={shades.secondary.medium}
        strokeWidth={strokeWidth}
      />
      <path
        className={strokeStyle}
        d="M18.36 42.95c-2.89.51-4.59-1.36-5.5-3.12 1.34-4.2 3.54-6.86 6.02-8.19 5.28 3.8 4.15 10.47-.52 11.31Z"
        fill={shades.secondary.medium}
        strokeWidth={strokeWidth}
      />
      <path
        className={strokeStyle}
        d="M37.42 49.66a5.16 5.16 0 0 1-8.01-.2c-1.99-2.46-.25-6.32 2.27-6.32s7.73 4.33 5.75 6.51z"
        fill={shades.secondary.medium}
        strokeWidth={strokeWidth}
      />
      <path
        className={strokeStyle}
        d="M56.07 77.29c15.86 0 28.72-1.9 28.72-4.25s-12.86-4.25-28.72-4.25-28.72 1.9-28.72 4.25 12.86 4.25 28.72 4.25Z"
        fill={shades.black}
        strokeWidth={strokeWidth}
      />
      <path className={strokeStyle} d="M104.92 9.85v2.19" strokeWidth={strokeWidth} />
      <path className={strokeStyle} d="M100.75 6.32h-1.97" strokeWidth={strokeWidth} />
      <path className={strokeStyle} d="M104.74 2.77V.57" strokeWidth={strokeWidth} />
      <path className={strokeStyle} d="M108.92 6.3h1.96" strokeWidth={strokeWidth} />
      <path className={strokeStyle} d="M3.32 19.54v5.26" strokeWidth={strokeWidth} />
      <path className={strokeStyle} d="M6.15 22.17H.5" strokeWidth={strokeWidth} />
    </svg>
  );
};
